export const formatCurrency = (amount) => {
  if (typeof (amount) === "string") {
    amount = parseFloat(amount);
  }

  return amount.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
};

// INPUT MASKS
const firstLetter = /(?!.*[DFIOQU])[A-VXY]/i;
const letter = /(?!.*[DFIOQU])[A-Z]/i;
const digit = /[0-9]/;
export const postalCodeMask = [firstLetter, digit, letter, " ", digit, letter, digit];

export const zipCodeMask = '99999';

export const phoneMask = '(999) 999-9999';

export const getCreditCardType = (creditCardNumber) => {
  const visa = new RegExp("^4[0-9]{12}(?:[0-9]{3})?$");
  const mastercard = new RegExp("^5[1-5][0-9]{14}$");
  const amex = new RegExp("^3[47][0-9]{13}$");

  if (visa.test(creditCardNumber)) {
    return "Visa";
  }

  if (mastercard.test(creditCardNumber)) {
    return "MasterCard";
  }

  if (amex.test(creditCardNumber)) {
    return "AMEX";
  }

  return "UNKNOWN";
};

export const logError = async ({ identifier, errorMessage }) => {
  const data = new FormData();
  data.append("identifier", identifier);
  data.append("errorMessage", errorMessage);

  await fetch("https://christmasdaddies.org/error_logger.php", {
    method: "POST",
    body: data,
  });
};